var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { IconButton, IconTypes } from "../Button";
export var CloseIcon = styled(IconButton).attrs({ icon: IconTypes.cross })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  cursor: pointer;\n"], ["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  cursor: pointer;\n"])), function (_a) {
    var top = _a.top;
    return top || 0;
}, function (_a) {
    var right = _a.right;
    return right || 0;
});
var templateObject_1;
